import { createSlice } from "@reduxjs/toolkit";
import { activateDeactivateHumanCategory, addHumanCategory, deleteHumanCategory, fetchHumanCategoriesTableColumnNames, updateHumanCategory } from "./thunk";
import { uploadCategoryIcon, uploadDarkIcon, fetchHumanCategories } from "../thunks";

const initialState = {
  humanCategories: [],
  ImageLoading: false,
  uploadedImage: null,
  DarkImageLoading: false,
  uploadedDarkImage: null,
  error: null,
  tableColumnNames: [],
};

const HumanCategoriesSlice = createSlice({
  name: "HumanCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch Human Categories Table Column Names
    .addCase(fetchHumanCategoriesTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchHumanCategoriesTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchHumanCategoriesTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })
    // Fetch Screens API
    .addCase(uploadDarkIcon.pending, (state) => {
        state.DarkImageLoading = true;
        state.error = null;
    })
    .addCase(uploadDarkIcon.fulfilled, (state, action) => {
        state.DarkImageLoading = false;
        state.uploadedDarkImage = action.payload;
    })
    .addCase(uploadDarkIcon.rejected, (state, action) => {
        state.DarkImageLoading = false;
        state.error = action.payload;
    })
    // Fetch Screens API
    .addCase(uploadCategoryIcon.pending, (state) => {
        state.ImageLoading = true;
        state.error = null;
    })
    .addCase(uploadCategoryIcon.fulfilled, (state, action) => {
        state.ImageLoading = false;
        state.uploadedImage = action.payload;
    })
    .addCase(uploadCategoryIcon.rejected, (state, action) => {
        state.ImageLoading = false;
        state.error = action.payload;
    })

    .addCase(fetchHumanCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchHumanCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.humanCategories = action.payload;
    })
    .addCase(fetchHumanCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(addHumanCategory.pending, (state) => {
        state.error = null;
    })
    .addCase(addHumanCategory.fulfilled, (state, action) => {
        state.humanCategories.unshift(action.payload);
    })
    .addCase(addHumanCategory.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(updateHumanCategory.pending, (state) => {
        state.error = null;
    })
    .addCase(updateHumanCategory.fulfilled, (state, action) => {
        const index = state.humanCategories.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.humanCategories[index] = action.payload;
        }
    })
    .addCase(updateHumanCategory.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(deleteHumanCategory.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteHumanCategory.fulfilled, (state, action) => {
        state.humanCategories = state.humanCategories.filter(
            (item) => item.ID !== action.payload[0].ID
        );
    })
    .addCase(deleteHumanCategory.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(activateDeactivateHumanCategory.pending, (state) => {
        state.error = null;
    })
    .addCase(activateDeactivateHumanCategory.fulfilled, (state, action) => {
        const index = state.humanCategories.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.humanCategories[index] = action.payload;
        }
    })
    .addCase(activateDeactivateHumanCategory.rejected, (state, action) => {
        state.error = action.payload;
    })
  },
});

export default HumanCategoriesSlice.reducer;
